import React from "react";
import Navbar from "../components/Navbar";

import Footer from "../components/Footer";
import ImageCarousel from "../components/Carousel";
import ProjectCard from "../components/ProjectCard";
import ProjectDesciption from "../components/ProjectDescription";

const Project1 = () => {
    const carouselImages = [
        {
          src: "./Semester_5/HauptBild3.webp",
          alt: "Model",
          text: "Model Oblique View"
        },
        {
          src: "./Semester_5/1.webp",
          alt: "Mountains",
          text: "Realistic View of Arovigno"
        },
        
      ];



/* "Fallsemester 2024
5th semester at Voser
Co-author Shiqi Xu
created with ArchiCAD, QGis, Photoshop"*/


    const title = "Arovigno";
    const subtitle = "A Protective Structure for Mountain Regions";
    const description = "Val Mara, a picturesque region near Lugano, is known for its mountainous landscape and idyllic villages. The PoLuMe project aims to revitalise the region by tackling transport, housing and environmental challenges. Key improvements include the extension of the motorway to reduce commuting times to Lugano, which will encourage the expansion of the villages as the region offers more affordable housing options compared to the city. In addition, climate change should increase the attractiveness of Val Mara, as the cooler summer climate and fresher air are a relief compared to the warmer conditions in Lugano and neighbouring areas such as Melano and Maroggia. Melano and Maroggia suffer from motorway noise, while Rovio and Arogno are reaching the limits of their capacity. One proposed solution is the development of a new village called Arovigno on the slopes of Monte Generoso between Rovio and Arovigno.";
    const secondDescription = "In mountainous regions, there is often a risk of rockfall, which is not negligible in Arovigno. The project therefore envisages a multifunctional protective infrastructure that will be built using excavated material from tunnelling. The structure consists of three protective walls that divert and stop falling rocks without damaging them. Water channels are provided on the back of the walls to skilfully drain away rainwater. On the front of the upper slopes are solar panels that collect the basic energy for the settlement. Terracing is planned to make the steep slope more accessible. A commercial forest will be planted on the protective structures along the walls, through which a hiking trail winds. A pond for storing water for regular use and for periods of drought is also part of the large protective structure. The pond next to the primary basin also serves as a collection point for falling stones, which are reused for the construction of houses and infrastructure.";
    const thirdDescription = "The aim of the project is to develop a system that can be applied to similarly affected regions. With this infrastructure, such villages can continue to grow without hesitation, which will become increasingly important in the future."
    const map = "./Semester_5/KarteValMara.webp";
    const semester = "Fallsemester 2024";
    const professosr = "5th semester at Voser";
    const tools = "created with ArchiCAD, QGis, Photoshop";
    const coAuthor = "Co-author Shiqi Xu";

    const cards = [
      {
        id: 1,
        content: <p>The PoLuMe project shortens the commute time between Melano, Maroggia and Lugano, making it more attractive to live in villages.</p>,
        className: "h-40 bg-blue-500",
        thumbnail: "./Semester_5/2.1.webp",
      },
      {
        id: 2,
        content: <p>Arovigno is located higher than its surrounding villages which gives it the benefit of cooler and calmer atmosphere, away from the motorway.</p>,
        className: "h-40 bg-red-500",
        thumbnail: "./Semester_5/2.22.webp",
      },
      {
        id: 3,
        content: <p>The hazard map shows in yellow the efficient areas for photovoltaic systems, in red the rockfall hazard zones and in blue the surface runoff area.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/3.webp",
      },
      {
        id: 4,
        content: <p>The three structures lead the rockfalls as gently as possible away from the existing houses and catch them in the designated basins.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/4.webp",
      },
      {
        id: 5,
        content: <p>The structures consist of a rock wall in the back, a commercial forest on the top part, continuing with PV systems along the steepest terrain and either agricultural or communal activities on the bottom part.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/5.webp",
      },
      {
        id: 6,
        content: <p>Floor plan upon building the three structures.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/6_1.webp",
      },
      {
        id: 7,
        content: <p>The smaller Structure with the agricutltural usage.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/7.webp",
      },
      {
        id: 8,
        content: <p>The commercial forest consists of a hiking trail that leads to a look out area with a bench every now and again.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/8.webp",
      },
      {
        id: 9,
        content: <p>The hiking trail on the top of the structure.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/9.webp",
      },
      {
        id: 10,
        content: <p>View of the smaller structure from the bottom.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/10.webp",
      },
      {
        id: 11,
        content: <p>The larger structure with the forest usage.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/11.webp",
      },
      {
        id: 12,
        content: <p>The larger structure contains a water basin that collects some of the falling rocks. A drainage system is incorporated to make sure the water will not overflow.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/12.webp",
      },
      {
        id: 13,
        content: <p>The larger deposit basin does not hold water but it leads rainwater in gutters along the stone walls.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/13.webp",
      },
      {
        id: 14,
        content: <p>The slope stabilisation is given by the wooden crib wall and the slope grate which is the substructure for the PV system.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/14.webp",
      },
      {
        id: 15,
        content: <p>The slope stabilisation is also given by the backfill in a 45 degree angle. It is foreseen that due to erosion the slope will be flattened down and the backfill will be caught by the plants that hold everything together.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/15.webp",
      },
      {
        id: 16,
        content: <p>The axonometric view showcasing how the terracing along the slope and along the walls come together and how they are navigable by the visitors.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/16.webp",
      },
      {
        id: 17,
        content: <p>Arovigno is set to grow through the structures that make the area safe to live. Additional housing and water basins can be built through time. With increasing population, a denser street system becomes crucial.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/19.gif",
      },
      {
        id: 18,
        content: <p>A future cut section through the water basins show the increased connection between water and the inhabitants. The water basins are accessible via hiking trails.</p>,
        className: "h-40 bg-green-500",
        thumbnail: "./Semester_5/18.webp",
      },
  
    ];
    
  return (
    <>
    <div className="pb-25 flex items-center justify-center bg-[#e7e5e4]">
        <Navbar />
    </div>
    
      <ImageCarousel images={carouselImages} title={title} />
      <ProjectDesciption subtitle={subtitle} description={description} secondDescription={secondDescription} thirdDescription={thirdDescription} map={map} semester={semester} professor={professosr} tools={tools} coAuthor={coAuthor}/>
      <ProjectCard cards={cards}/>
      <Footer />
    </>
  );
};

export default Project1;

